import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { setupManagementUrl } from "../../../config";
import Form from "./forms";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import ProductChargesTable from "../../SetupManagement/ProductCharge";
import ProductChargesAccountsTable from "../ProductChargesAccount";
import Joyride from "react-joyride"; // Import Joyride

//const base_url = setupManagementUrl.uri;
const base_url = setupManagementUrl.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Products setup page, where you can manage Products.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Products by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Product.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions to be able to Edit, access product charges and view product charges accounts for each Product from this dropdown.",
    placement: "left",
  },
];

// Only core, product-facing columns are shown in the table; everything else
// (audit fields, internal ids, and secondary product settings) is hidden here
// but remains editable via the product form.
const ignoreFields = [
  "PrecedenceOrder",
  "InterestMethodId",
  "InterestPaymentMethodId",
  "IsDepositRequired",
  "DepositRequired",
  "IsDepositPercentage",
  "CompanyId",
  "CreatedBy",
  "CreateDate",
  "UpdatedBy",
  "UpdateDate",
  "IsdynamicInstallment",
  "MinimumTerm",
  "maximumTerm",
  "LienGracePeriod",
  "InstallmentPenalty",
  "LoanTermGracePeriod",
  "MaxLtvPct",
  "IsSecuredproduct",
  "ArmotizeSchedule",
  "HasIncentive",
  "IsIncentivePercentage",
  "AllowInstallmentRepossesion",
  "IsBlankDisbursement",
  "HasPenalty",
  "IncentiveValue",
  "MinimumLoanPaid",
  "MinCommission",
  "MaxCommission",
];

const ProductsTable = () => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const [selectedProductId, setSelectedProductId] = useState(null);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId) 
  const Id = selectedProductId
  console.log("Current selectedProductId:", Id); // Log on every render

  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ProductChargesTable: {
      key: "ProductCharge",
      button_name: "Product Charges",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      
    },
    ProductChargesAccountsTable: {
      key: "ProductChargeAccount",
      button_name: "Product Charges Acc",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "productIds",
      inputObjectName: "bulkActivateDeactivateProducts",
    },
    AuditTrail: {
      key: "AuditTrail",
      button_name: "Audit Trail",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2], // Super Admin & Admin only
    },
    dataObject: {
      ignoreFields,
      objectName: "allProductsByColumnValues",
      inputObjectName: "parameters",
      parameters: {companyId: companyId},
    },
    showMore:{
      search:false,
      min: 0,
      max:0
    }
  };
  const handleAction = (actionType, productId) => {
    if (actionType === "ProductChargesTable") {
      setSelectedProductId(productId); // Set the selected product ID
    }
    // Handle other actions as needed
  };

  return (
    <Box m="20px">
       <Joyride
            steps={rightsTourSteps}
            run={runTour}
            continuous
            showSkipButton
            showProgress
            styles={{
              options: {
                primaryColor: "#1976d2",
                zIndex: 10000,
              },
            }}
          />
           <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
                    Start Page Tour
            </Button>
      {selectedProductId ? (
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Button onClick={() => setSelectedProductId(null)} variant="contained">
            Back to Products
          </Button>
         
          <ProductChargesTable Id={selectedProductId} />
          <ProductChargesAccountsTable Id={selectedProductId} /> 
        </Box>
      ) : (
        <DynamicTableForJson
          title="Products"
          subtitle="Manage Products"
          FormComponent={Form}
          base_url={base_url}
          actions={actions}
          onRowClick={(row) => handleAction(actions.ProductChargesTable.key, row.Id)} // Call handleAction with product ID
          setSelectedProductId={setSelectedProductId}
          tourSteps={rightsTourSteps} // Pass tour steps as prop

          />
      )}
    </Box>
  );
};

export default ProductsTable;
